module.exports = __webpack_public_path__ + "img/eyein-partner-nec.0e986437.webp";